import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import useAppShellSx from '../../hooks/useAppShellSx';

/** Collapsed-rail tooltips — Inter typography, scoped outside sidebar DOM tree. */
export default function SidebarTooltip({ title, children, placement = 'right', ...rest }) {
  const { sidebar, sidebarType } = useAppShellSx();

  if (!title) {
    return children;
  }

  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      enterDelay={350}
      enterNextDelay={200}
      leaveDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            ...sidebarType.tooltip,
            bgcolor: sidebar.bgElevated,
            color: sidebar.text,
            border: `1px solid ${sidebar.border}`,
            boxShadow: '0 8px 24px rgba(0,0,0,0.42)',
            maxWidth: 220,
          },
        },
        arrow: {
          sx: {
            color: sidebar.bgElevated,
            '&::before': {
              border: `1px solid ${sidebar.border}`,
            },
          },
        },
      }}
      {...rest}
    >
      {children}
    </Tooltip>
  );
}

SidebarTooltip.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
};
